import React from 'react';

/**
 * Özel Input bileşeni
 */
const Input = ({
  label,
  icon, // İkon prop'u doğrudan bileşene ekleniyor
  type = 'text',
  placeholder = '',
  labelId,
  name,
  value,
  onChange
}) => {
  return (
    <div className="row mb-4 align-items-center">
      <div className="col-lg-2">
        <label htmlFor={labelId} className="fw-semibold">
          {label}:
        </label>
      </div>
      <div className="col-lg-10">
        <div className="input-group">
          {/* İkon buraya doğrudan ekleniyor */}
          <div className="input-group-text">
            {icon}
          </div>
          <input
            type={type}
            name={name}
            className="form-control"
            id={labelId}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
          />
        </div>
      </div>
    </div>
  );
};

export default Input;
